import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Heading from 'components/shared/heading';
import IconicBlock from 'components/shared/iconic-block';

import shape1 from './svg/shape-1.svg';
import shape2 from './svg/shape-2.svg';

import styles from './home-seamless-system.module.scss';

const cx = classNames.bind(styles);

const HomeSeamlessSystem = ({ title, description, items }) => (
  <section className={cx('wrapper')}>
    <div className="container">
      <Heading className={cx('title')} tag="h2" size="xl">
        {title}
      </Heading>
      <Heading className={cx('description')} tag="p" size="lg" role="doc-subtitle">
        {description}
      </Heading>

      <ul className={cx('columns is-multiline', 'iconic-blocks-wrapper')}>
        {items.map(({ iconname, ...item }, index) => (
          <li
            className={cx('column is-12-mobile is-6-tablet is-3-desktop', 'iconic-block')}
            key={index}
          >
            <IconicBlock
              titleClassName={cx('iconic-block-title')}
              descriptionClassName={cx('iconic-block-description')}
              iconName={iconname}
              {...item}
            />
          </li>
        ))}
      </ul>

      <img className={cx('shape-1')} src={shape1} alt="" />
      <img className={cx('shape-2')} src={shape2} alt="" />
    </div>
  </section>
);

HomeSeamlessSystem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(IconicBlock.propTypes)).isRequired,
};

export default HomeSeamlessSystem;
